import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router, PRIMARY_OUTLET, NavigationEnd, RouterEvent } from '@angular/router';
interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
  allowLink: boolean;
}


@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {

  public breadcrumbs: IBreadcrumb[];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {

    this.breadcrumbs = [];
    this.router.events
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          let root: ActivatedRoute = this.activatedRoute.root;
          this.breadcrumbs = this.getBreadcrumbs(root);
        }

      });
  }

  ngOnInit() {
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    const ROUTE_DATA_ALLOWLINK: string = "allowLink";

    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      //append route URL to URL
      url += `/${routeURL}`;


      //add breadcrumb
      let breadcrumb: IBreadcrumb = {
        label: this.handleLabel(child.snapshot.data[ROUTE_DATA_BREADCRUMB], child.snapshot.params),
        params: child.snapshot.params,
        url: url,
        allowLink: child.snapshot.data[ROUTE_DATA_ALLOWLINK] ? child.snapshot.data[ROUTE_DATA_ALLOWLINK] : false
      };

      breadcrumb.url = this.handleUrl(breadcrumb.url, breadcrumb.allowLink);


      if (breadcrumb.label) {
        breadcrumbs.push(breadcrumb);
      }

      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }


  private handleLabel(label: string, params: Params) {

    var colonIndex: number = label.indexOf(":");

    if (colonIndex !== -1) {
      var value = label.substr(colonIndex + 1);
      return label.substr(0, colonIndex) + params[value];
    }

    return label;

  }

  private handleUrl(url: string, allowLink: boolean) {

    if (!allowLink) {
      return url.substr(0, url.lastIndexOf("/"));
    }

    return url;
  }

  public isLastChild(breadcrumb: IBreadcrumb) {
    var idx = this.breadcrumbs.indexOf(breadcrumb);
    return idx + 1 === this.breadcrumbs.length;
  }

}
